import { useCallback, useSyncExternalStore } from "react"

import { getAuthGeneration, subscribeAuthGeneration } from "@/api/auth-refresh-coordinator"

export function usePluginSessionGeneration() {
  return useSyncExternalStore(subscribeAuthGeneration, getAuthGeneration, getAuthGeneration)
}

/** Shared query keys stay within the authenticated session, including admin data. */
export function usePluginQueryKey() {
  const generation = usePluginSessionGeneration()
  return useCallback((...parts: unknown[]) => ["plugins", generation, ...parts], [generation])
}
